// extracted by mini-css-extract-plugin
export default {"plans":"Currencies_plans__k3pOp","buttonBox":"Currencies_buttonBox__pcZ2C","tables":"Currencies_tables__GVmzW","table":"Currencies_table__SoxN7"};